/* eslint-disable */
import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import menuJson from './menuJson.json';

export default createStore({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
  state: {
    menuList: menuJson.menuList,
    isLogin: false,
    empNo: undefined,
    empDiv: undefined,
    empNm: undefined,
    empMobile: undefined,
    checkTerms: false,
    checkSessionExpired: false,
  },
  getters: {
    getMenuList: state => state.menuList,
  },
  mutations: {
    isLogin: function (state, payload) {
      state.isLogin = payload;
    },
    logout: function (state, payload) {
      state.isLogin = false;
      state.empNo = payload;
      state.empDiv = payload;
      state.empNm = payload;
      state.empMobile = payload;
      state.menuList = menuJson.menuList;
    },
    empNo: function (state, payload) {
      state.empNo = payload;
    },
    empDiv: function (state, payload) {
      state.empDiv = payload;
    },
    empNm: function (state, payload) {
      state.empNm = payload;
    },
    empMobile: function (state, payload) {
      state.empMobile = payload;
    },
    checkTerms: function (state, payload) {
      state.checkTerms = payload;
    },
    checkSessionExpired: function (state, payload) {
      state.checkSessionExpired = payload;
    },
  },
  actions: {
    isLogin: function (context, payload) {
      context.commit('isLogin', payload);
    },
    logout: function (context, payload) {
      context.commit('logout', payload);
    },
    empNo: function (context, payload) {
      context.commit('empNo', payload);
    },
    empDiv: function (context, payload) {
      context.commit('empDiv', payload);
    },
    empNm: function (context, payload) {
      context.commit('empNm', payload);
    },
    empMobile: function (context, payload) {
      context.commit('empMobile', payload);
    },
    checkTerms: function (context, payload) {
      context.commit('checkTerms', payload);
    },
    checkSessionExpired: function (context, payload) {
      context.commit('checkSessionExpired', payload);
    },
  },
  modules: {},
});
